import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
  Alert,
} from "react-bootstrap";
import ReactDatetime from "react-datetime";
import { ServerActions } from "../actions/serverActions";

const OutageEdit = ({ onCancel, outage, setSuccessMessage }) => {
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState({
    bannerStartDateTime: moment(),
    outageStartDateTime: moment(),
    outageEndDateTime: moment().add(15, "minute"),
    outageSystem: "",
    outageMessage: "",
  });

  const isEdit = !!outage?.id;

  useEffect(() => {
    if (outage) {
      setFormValues({
        ...outage,
        bannerStartDateTime: moment(outage.bannerStartDateTime),
        outageStartDateTime: moment(outage.outageStartDateTime),
        outageEndDateTime: moment(outage.outageEndDateTime),
      });
    }
  }, [outage]);

  const onSubmit = () => {
    const data = {
      ...formValues,
      bannerStartDateTime: moment(formValues.bannerStartDateTime).format("YYYY-MM-DDTHH:mm:ss"),
      outageStartDateTime: moment(formValues.outageStartDateTime).format("YYYY-MM-DDTHH:mm:ss"),
      outageEndDateTime: moment(formValues.outageEndDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    };

    if (isEdit) {
      window
        .confirm("Confirm Update", {
          description:
            "Selecting Update Outage will overwrite the previous Outage and save current work. Are you sure you want to do this ?",
          confirmLabel: "Update",
          abortLabel: "Go Back",
        })
        .then(() => {
          data.id = outage.id;
          ServerActions.updateOutage(data)
            .done((res) => {
              if (res.success) {
                ServerActions.getOutageList();
                setSuccessMessage("Outage updated successfully");
              } else {
                setAlert(res?.errors?.join(", "));
              }
            })
            .fail(() => {
              setAlert(
                "Failed to Update outage, Please try again after sometime"
              );
            });
        });
    } else {
      ServerActions.createOutage(data)
        .done((res) => {
          if (res.success) {
            ServerActions.getOutageList();
            setSuccessMessage("Outage created successfully");
          } else {
            setAlert(res?.errors?.join(", "));
          }
        })
        .fail(() => {
          setAlert("Failed to Create outage, Please try again after sometime");
        });
    }
  };
  const onDelete = () => {
    window
      .confirm("Confirm Delete", {
        description:
          "Selecting Delete Outage will remove this Outage for all Users. Are you sure you want to do this ?",
        confirmLabel: "Delete",
        abortLabel: "Go Back",
      })
      .then(() => {
        ServerActions.deleteOutage(outage.id)
          .done((res) => {
            if (res.success) {
              ServerActions.getOutageList();
              setSuccessMessage("Outage deleted successfully");
            } else {
              setAlert(res?.errors?.join(", "));
            }
          })
          .fail(() => {
            setAlert(
              "Failed to Delete outage, Please try again after sometime"
            );
          });
      });
  };

  const updateFormValues = (data) =>
    setFormValues((values) => ({ ...values, ...data }));

  return (
    <table width="100%">
      <tr>
        <td>
          <div className="screenHeader">
            {isEdit ? "Update" : "Create"} Outage
          </div>
          {alert && (
            <Alert bsStyle="danger" onDismiss={() => setAlert(null)}>
              <p>{alert}</p>
            </Alert>
          )}
        </td>
      </tr>
      <tr>
        <td>
          <Form style={{ maxWidth: 840, margin: "auto" }} horizontal>
            <FormGroup controlId="outageSystem">
              <Col sm={3} componentClass={ControlLabel}>
                Outage System *
              </Col>
              <Col sm={9}>
                <FormControl
                  type="text"
                  value={formValues.outageSystem}
                  onChange={(e) =>
                    updateFormValues({ outageSystem: e.target.value })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="outageMessage">
              <Col sm={3} componentClass={ControlLabel}>
                Outage Message *
              </Col>
              <Col sm={9}>
                <textarea
                  className="form-control"
                  value={formValues.outageMessage}
                  onChange={(e) =>
                    updateFormValues({ outageMessage: e.target.value })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="bannerStartDate">
              <Col sm={3} componentClass={ControlLabel}>
                Banner Start Date Time *
              </Col>
              <Col sm={9}>
                <ReactDatetime
                  value={formValues.bannerStartDateTime}
                  onChange={(bannerStartDateTime) =>
                    updateFormValues({ bannerStartDateTime })
                  }
                  id="bannerStartDate"
                  dateFormat="MM/DD/YY"
                  timeFormat="HH:mm:ss"
                  closeOnSelect
                  inputProps={{
                    placeholder: "MM/DD/YY HH:mm:ss",
                    className: "form-control",
                    style: { minWidth: 200 },
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="outageStartDateTime">
              <Col sm={3} componentClass={ControlLabel}>
                Outage Start Date Time *
              </Col>
              <Col sm={9}>
                <ReactDatetime
                  value={formValues.outageStartDateTime}
                  onChange={(outageStartDateTime) =>
                    updateFormValues({ outageStartDateTime })
                  }
                  id="outageStartDateTime"
                  dateFormat="MM/DD/YY"
                  timeFormat="HH:mm:ss"
                  closeOnSelect
                  inputProps={{
                    placeholder: "MM/DD/YY HH:mm:ss",
                    className: "form-control",
                    style: { minWidth: 200 },
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="outageEndDateTime">
              <Col sm={3} componentClass={ControlLabel}>
                Outage End Date Time *
              </Col>
              <Col sm={9}>
                <ReactDatetime
                  value={formValues.outageEndDateTime}
                  onChange={(outageEndDateTime) =>
                    updateFormValues({ outageEndDateTime })
                  }
                  id="outageEndDateTime"
                  dateFormat="MM/DD/YY"
                  timeFormat="HH:mm:ss"
                  closeOnSelect
                  inputProps={{
                    placeholder: "MM/DD/YY HH:mm:ss",
                    className: "form-control",
                    style: { minWidth: 200 },
                  }}
                />
              </Col>
            </FormGroup>
          </Form>
        </td>
      </tr>
      <tr>
        <td>
          <div style={{ textAlign: "center" }}>
            <Button
              bsStyle="primary"
              className="adminButton"
              onClick={onSubmit}
            >
              {isEdit ? "Update" : "Save"} Outage
            </Button>
            {isEdit && (
              <Button
                bsStyle="danger"
                className="adminButton"
                onClick={onDelete}
              >
                Delete Outage
              </Button>
            )}
            <Button
              bsStyle="secondary"
              className="adminButton"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </div>
        </td>
      </tr>
    </table>
  );
};

export default OutageEdit;
